import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import stripAttr from 'strip-attributes'
import textReplace from 'utils/textReplace'
import textAsReactComponent from 'utils/textAsReactComponent'
import styles from './Quote.module.css'

const QuoteParagraph = ({ text }) => {
  let markup = stripAttr(textReplace(text.value), { omit: ['style'] })

  if (markup.includes('data-toggle="popover"')) {
    markup = textAsReactComponent(markup)
    return <blockquote className={styles.blockquote}>{markup}</blockquote>
  }

  return <blockquote className={styles.blockquote} dangerouslySetInnerHTML={{ __html: markup }} />
}

QuoteParagraph.propTypes = {
  text: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
}

const fragments = {
  paragraph: gql`
    fragment QuoteParagraphFragment on ParagraphQuote {
      id
      text: fieldText {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { QuoteParagraph, fragments }
